<template>
    <form-container
      v-if="hasAuth('Admin')"
      :header="translate('externalSignerImport.importFromExcel')"
      v-on:save="save"
      :disabled="loading"
    >
      <div class="row">
        <form @submit.prevent="saveUploadedUsers" :disabled="loading">
          <div class="col-12">
            <div class="dashboard-container">
              <div class="info">
                <p>
                  <strong>{{translate('externalSignerImport.warning')}}:</strong> 
                  <span v-html="translate('externalSignerImport.text')"></span>
                  <br>
                  <br>
                </p>
                <button
                  class="btn btn-info btn-download-template"
                  @click="downloadTemplate()"
                >
                {{translate('externalSignerImport.downloadSampleFile')}}
                </button>
              </div>
              <div class="button_group">
                <a
                  href="javascript:;"
                  class="
                    button_s
                    my_file
                    el-button
                    button_s
                    el-button--primary el-button--small
                  "
                >
                  <div class="inline" style="display: flex">
                    <input
                      type="file"
                      class="my_input form-control"
                      @change="importExcel"
                      id="upload"
                    />
                    <label
                      for="upload"
                      style="
                        border-radius: 0;
                        cursor: pointer;
                        text-decoration: none !important;
                      "
                      class="custom-file-upload"
                    ></label>
                  </div>
                </a>
              </div>
            </div>
          </div>
          <div class="row validation-result-container">
            <table
              class="table table-borderless user-table"
              :class="{ 'table-striped': externalSignerList, 'table-hover': externalSignerList }"
              v-show="externalSignerList.length > 0"
            >
              <thead>
                <tr>
                  <th scope="col">{{translate('externalSignerImport.processStatus')}}</th>
                  <th scope="col">{{translate('externalSignerImport.nameSurname')}}</th>
                  <th scope="col">{{translate('externalSignerImport.informationMessage')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="externalSigner in externalSignerList" :key="externalSigner">
                  <td scope="row" v-show="externalSigner.Status == true">
                    <svg
                      width="20"
                      version="1.1"
                      id="Capa_1"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                      x="0px"
                      y="0px"
                      viewBox="0 0 50 50"
                      style="enable-background: new 0 0 50 50"
                      xml:space="preserve"
                    >
                      <circle style="fill: #25ae88" cx="25" cy="25" r="25" />
                      <polyline
                        style="stroke: #ffffff;
                        stroke-width: 2;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-miterlimit: 10;
                        "
                        points="38,15 22,33 12,25 "
                      />
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                      <g></g>
                    </svg>
                  </td>
                  <td scope="row" v-show="externalSigner.Status == false">
                    <svg
                      width="20"
                      height="32"
                      style="overflow: visible; enable-background: new 0 0 32 32"
                      viewBox="0 0 32 32"
                      xml:space="preserve"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlns:xlink="http://www.w3.org/1999/xlink"
                    >
                      <g>
                        <g id="Error_1_">
                          <g id="Error">
                            <circle
                              cx="16"
                              cy="16"
                              id="BG"
                              r="16"
                              style="fill: #d72828"
                            />
                            <path
                              d="M14.5,25h3v-3h-3V25z M14.5,6v13h3V6H14.5z"
                              id="Exclamatory_x5F_Sign"
                              style="fill: #e6e6e6"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </td>
                  <td scope="row" v-show="externalSigner.Status == null"></td>
                  <td>{{ externalSigner.Name }} {{ externalSigner.Surname }}</td>
                  <td>{{ externalSigner.ValidationMessage }}</td>
                </tr>
              </tbody>
            </table>
            <div v-if="this.hasGeneralError == true" style="width: 100%">
                <div class="alert alert-warning">
                    <p>
                        {{this.generalMessage}}
                    </p>
                </div>
            </div>
          </div>
        </form>
      </div>
      <template v-slot:footer>
            <div class="row">
                <div class="col">
                    <button type="button"  v-on:click="goBack" class="btn btn-outline-primary">{{translate('goBack')}}</button>
                </div> 
            </div>
        </template>

    </form-container>
    <div v-else class="alert alert-danger">
      {{translate('errors.notAuthorizedForTheProcess')}}
    </div>
  </template>
  
  <script>
  import axios from "axios";
  import formMixin from "../formMixin.js";
  
  import xlsx from "xlsx";

  
  import formContainer from "../components/FormContainer.vue";
  
  export default {
    mixins: [formMixin],
    components: {
      formContainer,
    },
    created() {
      this.data = Object.assign({}, this.model);
    },
    props: {
      value: Object,
      model: Object,
    },
    data() {
      return {
        loading: false,
        modelName: 'ExternalSigner',
        externalSignerList: [],
        userFile: [],
        errorMessage: "",
        hasGeneralError: false,
        generalMessage: "",
      };
    },
    methods: {
      downloadTemplate() {
        window.open("../../Files/external_signer_import_template.xlsx");
      },
      importExcel(e) {
        console.log("Deneme");
        const files = e.target.files;
        console.log(files);
        if (!files.length) {
          return;
        } else if (!/\.(xls|xlsx)$/.test(files[0].name.toLowerCase())) {
          return alert(this.translate('errors.uploadFormatIncorrectXLS'));
        }
        const fileReader = new FileReader();
        fileReader.onload = (ev) => {
          try {
            const data = ev.target.result;
            const XLSX = xlsx;
            const workbook = XLSX.read(data, {
              type: "binary",
              cellDates: true,
            });
            const wsname = workbook.SheetNames[0];
            const ws = XLSX.utils.sheet_to_json(workbook.Sheets[wsname]);
            const excellist = [];
            for (var i = 0; i < ws.length; i++) {
              excellist.push(ws[i]);
            }
  
            this.externalSignerList = excellist;
            this.prepareData();
  
            console.log("Read results111", Object.assign([], excellist));
            console.log("Read results", excellist);
          } catch (e) {
            return alert(this.translate('errors.fileReadError'));
          }
        };
        fileReader.readAsBinaryString(files[0]);
        var input = document.getElementById("upload");
        input.value = "";
      },
  
      prepareData() {
        this.externalSignerList.forEach((externalSigner) => {
          externalSigner.Status = null;
          externalSigner.ValidationMessage = "";
        });
        this.validate();
      },
  
      compareString(val) {
        if (val == undefined || val == null || val == "") {
          return false;
        }
  
        console.log(val);
        console.log(val.toLowerCase().localeCompare("e") == 0 ? true : false);
        return val.toLowerCase().localeCompare("e") == 0 ? true : false;
      },
  
      validate() {
        axios
          .post("/externalSigner/ValidateExternalSigners", this.externalSignerList)
          .then((x) => {
            console.log("POST Result:", x.data);
            this.data = x.data;
            if (x.data.IsError) {
              if (x.data.Status == undefined) {
                this.handleValidationResult(x.data);
              } else {
                alert(x.data.ErrorMessages);
                x.externalSignerList = [];
                this.$forceUpdate();
              }
            } else {
              this.handleSuccesResult();
            }
          })
          .catch((x) => {
            this.errorMessage = this.translate('errors.processFailed') + x;
          })
          .then(() => {
            this.loading = false;
          });
      },
      handleSuccesResult() {
        this.externalSignerList.forEach((externalSigner) => {
          externalSigner.Status = true;
          externalSigner.ValidationMessage = this.translate('messages.externalSignerAdded');
        });
        this.$forceUpdate();
      },
      handleValidationResult(result) {
        console.log(result)
        this.externalSignerList.forEach((externalSigner) => {
          let error = result.Data.filter(
            (x) => x.Key == String(externalSigner.Name)
          );
          if (error != null && error.length > 0) {
            externalSigner.Status = false;
            externalSigner.ValidationMessage = error[0].Error.toString();
            this.hasGeneralError = true;
            this.generalMessage = this.translate('errors.usersCantBeAdded')
          } else {
            externalSigner.Status = true;
            externalSigner.ValidationMessage = this.translate('messages.validated')
          }
        });
        this.$forceUpdate();
      },
    },
  };
  </script>
  
  
  
  <style  scoped>
  .user-table {
    margin-left: 20px;
    margin-right: 20px;
  }
  .btn-save {
    margin-left: 50%;
    width: 15%;
    border-radius: 12px;
  }
  .btn-download-template {
    float: right;
    margin-top: -33px;
    border-radius: 12px;
  }
  .danger {
    background-color: #ffdddd;
    border-left: 6px solid #f44336;
  }
  
  .success {
    background-color: #ddffdd;
    border-left: 6px solid #4caf50;
  }
  
  .info {
    padding: 20px;
    background-color: #e7f3fe;
    border-left: 6px solid #2196f3;
  }
  
  .warning {
    background-color: #ffffcc;
    border-left: 6px solid #ffeb3b;
  }
  input[type="file"] {
    display: inline-block;
    opacity: 0;
    position: absolute;
    margin-left: 20px;
    margin-right: 20px;
    padding-top: 30px;
    padding-bottom: 67px;
    width: 85%;
    z-index: 99;
    margin-top: 10px;
    cursor: pointer;
  }
  .custom-file-upload {
    position: relative;
    display: inline-block;
    cursor: pointer;
    padding-top: 40px;
    padding-bottom: 40px;
    background: url(../assets/uploadIcon.png) #fff center center no-repeat;
    width: 91%;
    border: 1px dashed #ff5b57 !important;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: 10px;
    text-align: center;
  }
  
  button {
    padding: 8px;
    border-radius: 3px;
  }
  
  button:hover {
    background-color: #2196f3;
    color: white;
  }
  .button_s {
    width: 78px;
    margin: 5px 10px 5px 5px;
  }
  .button_m {
    width: 100px;
    margin: 5px 10px 5px 5px;
  }
  .my_file {
    position: relative;
  }
  .my_input {
    /* position: absolute;
        opacity: 0;
        width: 78px;
        height: 30px;
        top: 0;
        left: 0; */
  }
  </style>
  
  